import { ColumnParams } from './types'

export const ListingFilters = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}

export const PAGE_SIZES = [10, 15, 25, 50, 100]

export const DEFAULT_PER_PAGE = 10

export const ENABLED_COLUMNS_STORAGE_KEY = (market: string) => `listingManagerEnabledColums:${market}`

export const applyEnabledColumns = (
  columns: ColumnParams[],
  enabledColumns: Record<string, boolean> = {}
): ColumnParams[] => columns.map(c => ({ ...c, show: enabledColumns[String(c.id)] ?? true }))

export const isCustomizableColumn = (column: ColumnParams): boolean => Boolean(column?.Header) || column?.id === 'thumb'

export const visibleCustomizableColumnCount = (columns: ColumnParams[]): number =>
  columns.filter(c => isCustomizableColumn(c) && c.show !== false).length
